export default function (umbrella) {
  function loadScope(url, scope, identity, crossorigin) {
    return new Promise(function ($return, $error) {
      var isLocalhost, isUrlLocalhost, remoteUrl, hasError, jsonUrl, version, element, promise;
      isLocalhost = window.location.hostname.indexOf('localhost') >= 0;
      isUrlLocalhost = url.indexOf('localhost') >= 0;
      remoteUrl = url;
      //if there's an identity, which is needed to get the json, try to get the json version file
      if (identity) {
        hasError = false;
        jsonUrl = "https://".concat(isLocalhost ? 'qa.recognition-now.io' : window.location.hostname, "/umbrella-path-versions/").concat(identity, ".json");
        return Promise.resolve(fetch(jsonUrl).then(function (response) {
          return response.json();
        }).then(function (data) {
          return data.version;
        }).catch(function (error) {
          if (error) {
            //if there's an error it means we got html back because the json file doesn't exist
            hasError = true;
          }
        })).then(function ($await_3) {
          try {
            version = $await_3;
            if (!hasError && version) {
              if (!isLocalhost) {
                //append version to base url because that's where the js will be
                remoteUrl = "".concat(url, "/").concat(version);
              } else if (isLocalhost && !isUrlLocalhost) {
                //if it's localhost and the url is not localhost, then we need to append the version to the url
                remoteUrl = "".concat(url, "/").concat(version);
              }
            }
            return $If_2.call(this);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }.bind(this), $error);
      } else {
        return $error(new Error('No identity provided, cannot look up version info for module federation'));
      }
      function $If_2() {
        element = document.createElement('script');
        promise = new Promise(function (resolve, reject) {
          element.src = "".concat(remoteUrl, "/remoteEntry.js");
          element.type = 'text/javascript';
          element.async = true;
          if (crossorigin === true) {
            element.crossOrigin = 'anonymous';
          }
          element.onload = function () {
            return resolve(window[scope]);
          };
          element.onerror = function () {
            return resolve();
          };
        });
        promise.catch(function (error) {
          //do nothing
          return;
        });
        document.head.appendChild(element);
        promise.finally(function () {
          return document.head.removeChild(element);
        });
        return $return(promise);
      }
      return $If_2.call(this);
    });
  }
  function loadModule(url, scope, module, identity) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var crossorigin, container, factory;
      crossorigin = $args.length > 4 && $args[4] !== undefined ? $args[4] : false;
      var $Try_1_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      var $Try_1_Catch = function (error) {
        try {
          return $Try_1_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      } // do nothing
      ;
      try {
        return Promise.resolve(loadScope(url, scope, identity, crossorigin)).then(function ($await_4) {
          try {
            container = $await_4;
            return Promise.resolve(__webpack_init_sharing__('default')).then(function ($await_5) {
              try {
                return Promise.resolve(container.init(__webpack_share_scopes__.default)).then(function ($await_6) {
                  try {
                    return Promise.resolve(container.get(module)).then(function ($await_7) {
                      try {
                        factory = $await_7;
                        return $return(factory());
                      } catch ($boundEx) {
                        return $Try_1_Catch($boundEx);
                      }
                    }, $Try_1_Catch);
                  } catch ($boundEx) {
                    return $Try_1_Catch($boundEx);
                  }
                }, $Try_1_Catch);
              } catch ($boundEx) {
                return $Try_1_Catch($boundEx);
              }
            }, $Try_1_Catch);
          } catch ($boundEx) {
            return $Try_1_Catch($boundEx);
          }
        }, $Try_1_Catch);
      } catch (error) {
        $Try_1_Catch(error)
      }
    });
  }
  umbrella.loadModule = loadModule;
}
//# sourceMappingURL=module-federation.js.map